import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";
import { Typography, type TypographyProps } from "@mui/material";

type Props = BaseProductElementProps &
  Omit<TypographyProps, "children"> & {
    truncate?: boolean;
  };

export const DescriptionV2 = (props: Props) => {
  const product = useProductContext(props);

  return <Typography {...props}>{product.description}</Typography>;
};
